import React from 'react';
import { OverlayComponent } from 'app/components';
import { hasTranslationsValid } from 'app/components/translation/has-translations-valid';
import { validateDefaultFilters } from 'app/area/shared/default-filters/utils/validate-default-filters';
import { DefaultFilterValidation } from 'app/area/shared/default-filters/types-store';

import { validateDashboard } from '../utils/validate-dashboard';
import { DashboardAdminFormState, DashboardItem, DashboardItemValidation } from '../types-store';
import { DashboardAdminTranslation } from '../../constants';

import { DashboardStickyHeader } from './dashboard-sticky-header';

interface DashboardContainerProps {
  formState: DashboardAdminFormState;
  favouriteId: number;
  mainLanguage: number;
  shouldPrompt: boolean;

  switchTranslationsToggle: (value: boolean) => void;
  saveDashboard: (item: DashboardItem) => void;
  deleteDashboard: () => void;
  updateValidation: (validation: DashboardItemValidation) => void;
  updateFiltersValidation: (validation: { [domain: number]: DefaultFilterValidation }) => void;
  displayError: (errorMessage: string) => void;

  validation: DashboardItemValidation;
  translation: DashboardAdminTranslation;
  children?: React.ReactNode;
}

export const DashboardContainer: React.FC<DashboardContainerProps> = ({
  formState, favouriteId, mainLanguage, shouldPrompt,
  switchTranslationsToggle,
  saveDashboard, deleteDashboard, updateValidation, updateFiltersValidation, displayError,
  translation,
  children
}) => {

  const { dashboardItem, filters, fetching, saving, deleting, languageOptions, validation } = formState;

  const onSave = () => {
    const formValidation = validateDashboard(dashboardItem, languageOptions, translation.must_be_filled_out);
    const defaultFiltersValidation = validateDefaultFilters(filters, translation);

    updateValidation({ ...validation, ...formValidation });
    updateFiltersValidation(defaultFiltersValidation);

    if (Object.keys(formValidation).length > 0 || Object.keys(defaultFiltersValidation).length > 0) {
      !hasTranslationsValid(formValidation.language, mainLanguage) && switchTranslationsToggle(true);
      displayError(translation.fields_are_filled_out_incorrectly);
      return;
    }

    saveDashboard(dashboardItem);
  };

  const dashboardName = dashboardItem.language
    ?.find(languageItem => languageItem.value === mainLanguage)
    ?.description;

  return <>
    <OverlayComponent
      displayOverlay={saving || deleting}
      overlayText={saving
        ? translation.saving_dashboard
        : translation.deleting_dashboard} />
    <DashboardStickyHeader
      dashboardItem={dashboardItem}
      favouriteId={favouriteId}
      name={dashboardName}
      shouldPrompt={shouldPrompt}
      fetching={fetching}
      onSave={onSave}
      onDelete={deleteDashboard}
      translation={translation} />
    {children}
  </>;
};
